import React, {Fragment} from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";

import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import LookMainFeatureGroupsExpandIcon from "./lookMainFeatureGroupsExpandIcon";
import {getLookIdUrl} from "../lookFunctions2";
import {ROUTES} from "../../../../routes";
import {setWizardActiveItem} from "../../../../actions/wizardFunctions";
import {IS_PRODUCT_JOURNEY} from "../../../../config";

import {setLookPageOpened} from "../../../../actions/lookFunctions";
import {wizardIsDisabled} from "./lookWizard/lookWizardFunctions";

const LookMainWizardList = (props) => {

  const {wizardList, history, activePreset, setWizardActiveItem, isMobile, setLookPageOpened, shopPageOpened
  } = props;

  if (!Array.isArray(wizardList) || !wizardList.length || wizardList.every(wizardItem => wizardIsDisabled(wizardItem, activePreset))) {
    return null
  }

  const parentClick = (wizardItem) => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookMenuWizard + Analytics.getStringForAnalytics(wizardItem.name));
    setWizardActiveItem(wizardItem);
    setLookPageOpened("");

    if (!shopPageOpened) {
      history.push(`${getLookIdUrl(false) + ROUTES.wizard}/${wizardItem.id}`);
    }
  }

  return (
    <Fragment>
      {wizardList.map(wizardItem => {
        if (wizardIsDisabled(wizardItem, activePreset) || wizardItem.hideInMenu) {
          return null
        }
        const {customImageUrl, uploadedImageUrl} = wizardItem;

        if (isMobile || IS_PRODUCT_JOURNEY) {
          return (
            <MenuItem className="look-sidebar__modal-item"
                      data-key={wizardItem.id}
                      key={wizardItem.id}
                      onClick={() => parentClick(wizardItem)}>
              <ListItemIcon>
                <AutoFixHighIcon/>
              </ListItemIcon>
              {wizardItem.name}
            </MenuItem>
          )
        }

        return (
          <li className="lm-parent"
              data-key={wizardItem.id}
              key={wizardItem.id}
              onClick={() => parentClick(wizardItem)}>
            <div className="lm-feature__thumbnail">
              {customImageUrl || uploadedImageUrl ? (
                <div className="feature-thumbnail" style={{
                  background: `url(${customImageUrl || uploadedImageUrl}) center / contain no-repeat`,
                }}/>
              ) : null}
            </div>
            <div className="lm-parent__content">
              <span className="lm-feature__content-name">{wizardItem.name}</span>
              <p className="lm-parent__content-name">{wizardItem.description}</p>
            </div>
            <LookMainFeatureGroupsExpandIcon/>
          </li>
        )
      })}
    </Fragment>
  )
};

const mapStateToProps = (store) => {
  const {wizardList} = store.wizardState;
  const {activePreset} = store.bathroomVisualizerState;
  const {isMobile} = store.serverState;
  const {shopPageOpened} = store.shopState;

  return {
    wizardList,
    activePreset,
    isMobile,
    shopPageOpened,
  };
};

const mapDispatchToProps = {
  setWizardActiveItem,
  setLookPageOpened
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(LookMainWizardList)
  )
)
